import React, { useEffect, useState } from 'react'
import { useBumenListQuery } from '../../store/DianShangYeWuApi';   
import { Divider, Form, Select, Space } from 'antd';

function DeptSelect(props) {
    const form = Form.useFormInstance();
    const [list,setList] = useState();
    const [hasFetched, setHasFetched] = useState(false);
    const [open, setOpen] = useState(false);
    const {data,isSuccess,refetch} = useBumenListQuery(
        {d_qy_id:props.qy_id},{refetchOnMountOrArgChange:1}
    )
    useEffect(() => {
        if(isSuccess){
            if(data.Status==='success'){                
                const newArr = data.Result.map((item) => {
                    const {d_id,d_name }=item;
                    // 统一转换为字符串类型，确保类型一致
                    return item = {value:String(d_id),label:d_name,key:String(d_id)}
                })
                setList(newArr)
            }
        }
    },[data,isSuccess])
    
    // 支持 defaultId 属性，在选项列表加载完成后设置默认值
    useEffect(() => {
        if(props.defaultId && list && list.length > 0 && form && props.name) {
            // 统一转换为字符串类型
            const normalizedId = String(props.defaultId);
            // 检查 defaultId 是否在选项列表中存在
            const exists = list.some(item => String(item.value) === normalizedId);
            if(exists) {
                // 获取当前 Form 的值
                const currentValue = form.getFieldValue(props.name);
                // 如果当前值不存在或与 defaultId 不同，则设置默认值
                if(!currentValue || String(currentValue) !== normalizedId) {
                    form.setFieldsValue({ [props.name]: normalizedId });
                }
            }
        }
    }, [props.defaultId, list, form, props.name])

    const handleOpenChange = (openState) => {
        setOpen(openState);
        if(openState && !hasFetched && props.qy_id){
            refetch();
            setHasFetched(true);
        }
    }
    const handleQuickSelect = (value, label) => {
        // 设置 Form 的值
        if (form && props.name) {
            form.setFieldsValue({ [props.name]: value });
        }
        // 触发 onChange 回调
        props.onChange(value, label);
        // 关闭下拉菜单
        setOpen(false);
    };
    return (
         <Form.Item 
            label={props.label} 
            required  
            style={props.formStyle}
            name={props.name}
            normalize={(value) => value === '' ? undefined : value}
            wrapperCol={props.wrapperCol}
        >
            <Select
                options={list} 
                onChange={(_,f) => {
                    if(f){
                        props.onChange(f.value,f.label,)
                    }
                }}
                placeholder={props.placeholder}
                style={props.style}
                allowClear
                onClear={props.onClear}
                disabled={props.disabled}
                open={open}
                onOpenChange={handleOpenChange}
                popupRender={menu => (
                    <>
                      {menu}
                      <Divider style={{ margin: '8px 0' }}/>
                      <div>常用：<Space>{props.list && props.list.length > 0 && props.list.map((item) => {
                        return <a key={item.value} onClick={() => handleQuickSelect(item.value, item.label)}>{item.label}</a>
                      })} </Space></div>                     
                    </>
                  )}
            />                        
        </Form.Item>
    )
}

export default DeptSelect

